module.exports = __webpack_public_path__ + "static/media/card-hosting-mobile-es.257853e8.png";